import React from 'react'

const TrailerItemTitle = ({title}) => (
    title ? (
        <h5 className="grid-title">
            <span className="title-large">{title}</span>
        </h5>
     ) : ''
)

export default TrailerItemTitle